import { z } from 'zod';
import { permission, roleKey } from './permissions.js';
export const inviteMemberInput = z.object({
    email: z.email('Correo inválido').trim().toLowerCase(),
    name: z.string().trim().min(2, 'Requerido').max(120),
    role: roleKey,
});
export const updateMemberInput = z
    .object({
    role: roleKey.optional(),
    status: z.enum(['active', 'disabled']).optional(),
})
    .refine((v) => v.role !== undefined || v.status !== undefined, { message: 'Nada para actualizar' });
/**
 * Permisos propios de un miembro. `null` = vuelve a los de su rol. Solo se aceptan permisos de módulos que la
 * compañía tiene activos; al propietario no se le recortan.
 */
export const memberPermissionsInput = z.object({ permissions: z.array(permission).nullable() });
//# sourceMappingURL=members.js.map